<template>
  <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab-6">
    <div class="form-row">
      <div class="col-md-12">
        <div class="innerbox pb-1 pt-2">
          <h2 class="mb-0">Gewerkeliste</h2>
          <div class="inrbox pb-2">
            <div class="col-md-7 pl-0 screen-height pr-0">
              <table class="table table-sm">
                <thead class="border table-head">
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Nummer</th>
                  <th scope="col">Code</th>
                  <th scope="col">Leistungsbezeichnung</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(service, index) in services" :key="index">
                  <td scope="row">
                    <div class="custom-control custom-checkbox">
                      <input v-model="service.checked" :true-value="'true'" @change="updateService(service)" :false-value="'false'" type="checkbox" class="custom-control-input" :id="'check'+service.servicenumber+service.pdserviceid">
                      <label class="custom-control-label" :for="'check'+service.servicenumber+service.pdserviceid"></label>
                    </div>
                  </td>
                  <td>{{service.pdserviceid}}</td>
                  <td>{{service.servicenumber}}</td>
                  <td>{{service.pdservicetitle}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="btninner float-right" style="margin-top: -12px">
            <button type="button" class="btn btn-danger mb-2" data-dismiss="modal" @click="$router.push({name: 'photo', params: {id: $route.params.id}})">
              Verlassen
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'trades',
  data(){
    return {}
  },
  created () {
    this.$store.dispatch("getProjectServices",this.$route.params.id);
  },
  computed : {
    services(){
      return this.$store.state.appSettings.projectServices
    }
  },
  methods: {
     updateService(service){
       let payload = {id : this.$route.params.id , service : service};
        this.$store.dispatch("updateProjectServices",payload)
      }
  },
  mounted () {

  }
}
</script>

<style scoped>
.screen-height{
  height: calc(100vh - 205px);
}
thead.table-head{
  position: sticky;
  top: 0;
  background: lightgray;
  z-index: 9999;
}
thead.table-head th{
  border: 1px solid lightgrey;
}
.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  margin-left: 0;
  margin-top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/Trades.vue